import { ModalsStateManagementDTO } from "./interface";

export const CloseAllModal:ModalsStateManagementDTO = {
  isTermsAgreement: {
    agreementExpired: false
  },
    isCopy: {
      isCopyLinkModal: false
    },
    isView: {
      isNameplate:false,
    },
    isAdd: {
      isEquipment: false,
      isContactModal: false,
      isDiscussionPost: false,
      isNameplate:false,
      isNameplateSamePage:false,
      isUnit:false,
      isPartsListDocument: false,
      isAttachNameplateAsset: false,
      isQuoteRequest: false,
    },    
    isDelete: {
      isEquipment: false,
      isPlantConfig: false, 
      isDiscussionPost: false,
      isNameplate:false,
      isUnit:false,
      isQuoteRequest: false,
    },
    isEdit: {
      isEquipment: false,  
      isPlantConfig: false,
      isDiscussionPost: false,   
      isUnit:false,
      isContactModal: false,
      isNameplate:false,
      isFaq:false,
      isPartsListDocument: false,
      isAttachNameplateAsset: false,
      isQuoteRequest: false,
    },    
    isDeleteSuccess:{
      isEquipment: false,
      isContactModal: false,
      isDiscussionPost: false,
      isPlantConfig: false,
      isNameplate:false,
      isUnit:false,
      isQuoteRequest: false,
    },
    isAddedSuccess:{
      isEquipment: false,
      isContactModal: false, 
      isNameplate:false, 
      isDiscussionPost: false,
      isNameplateSamePage:false,
      isUnit:false,
      isQuoteRequest: false,
    },
    isEditedSuccess:{
      isEquipment: false,
      isUnit:false,
      isContactModal: false,  
      isFaq: false,
      isDiscussionPost: false,
      isPlantConfig: false,
      isNameplate:false,
      isQuoteRequest: false,
    }
  };